module.exports = __webpack_public_path__ + "media/trazo 1.3248d9f5.mp4";